import * as React from 'react';

import NetworkIndicator from '../../Network/NetworkIndicator';
import SocketIndicator from '../../Socket/SocketIndicator';
import DeviceVerificationStatus from '../../Device/Verification/DeviceVerificationStatus';
import DisplayAuthenticator from '../../Authentication/DisplayAuthenticator';
import ActiveAppletStatus from '../../Applet/ActiveAppletStatus';

import styles from './StatusBar.module.sass';

export default () => {
	return (
		<div className={styles.container}>
			<NetworkIndicator />
			<SocketIndicator />
			<DisplayAuthenticator />
			<DeviceVerificationStatus />
			<ActiveAppletStatus />
		</div>
	);
};
